import constants from '../constants';

const getEventDomain = (domain) => {
  const { protocol } = window.location;
  return `${protocol}//${domain}.${constants.domainBase}`;
};

export default getEventDomain;
